import { isCommitmentLineItem, isPromotionLineItem, isProductLineItem } from '@weft/services';
import type { LineItem } from '@weft/types';
import { isFixedLineItem, isPerUnitLineItem, isTiersUsageLineItem,
  isUsageLineItem, 
  isVolumeBasedTiersLineItem } from '../../../../libs/services/src/line-items-filter/line-items-filter-implementations';

export function useLineItemsSplitter(lineItems: LineItem[]) {
  const productLineItems = lineItems.filter(isProductLineItem);

  const fixedLineItems = productLineItems.filter(isFixedLineItem);
  const usageLineItems = productLineItems.filter(isUsageLineItem);
  const tiersUsageLineItems = productLineItems.filter(isTiersUsageLineItem);
  const perUnitUsageLineItems = productLineItems.filter(isPerUnitLineItem);
  const commitmentLineItems = productLineItems.filter(isCommitmentLineItem);
  const volumeTiersLineItems = productLineItems.filter(isVolumeBasedTiersLineItem);

  const promotionLineItems = lineItems.filter(isPromotionLineItem);

  return { fixedLineItems, usageLineItems, tiersUsageLineItems, perUnitUsageLineItems, commitmentLineItems, promotionLineItems, volumeTiersLineItems };
}